import React from 'react';
import { Nullable } from 'src/types/nullable.type';
import { formatUnixTimestampSecondsToDate } from 'src/utils/date';

export const DashboardSettingsBillingCurrentPlanFactory = (
  subscription: Nullable<any>,
  {
    isSubscribed,
    isOnTrial,
    isCanceledAtPeriodEnd,
    billableUserCountText,
    renewsOnText,
  }: {
    isSubscribed: boolean;
    isOnTrial: boolean;
    isCanceledAtPeriodEnd: boolean;
    billableUserCountText: string;
    renewsOnText: string;
  }
) => {
  const getSubscriptionPricePerUser = () => subscription.plan.amount / 100;

  const getSubscriptionPrice = (): string => {
    const priceForPerUser = getSubscriptionPricePerUser();
    if (subscription.plan.transform_usage === null) {
      const totalSubscriptionPrice = priceForPerUser * subscription.quantity;
      return `$${totalSubscriptionPrice}/${subscription.plan.interval} for ${billableUserCountText}`;
    }
    const quota = subscription.plan.transform_usage.divide_by;
    return `$${priceForPerUser}/quarter for ${quota} ${quota === 1 ? 'user' : 'users'}`;
  };

  if (isSubscribed) {
    if (isCanceledAtPeriodEnd) {
      const willBeCanceledAt = formatUnixTimestampSecondsToDate(subscription.cancel_at);
      return () => (
        <span className='text-bedrock-p-strong'>Your Pro plan will be switched to Free on {willBeCanceledAt}</span>
      );
    }

    const subcriptionHasNoPrice = !isSubscribed && !isOnTrial;

    return () => (
      <>
        {subcriptionHasNoPrice ? null : (
          <p className='text-bedrock-p-strong'>
            {getSubscriptionPrice()} - {renewsOnText}
          </p>
        )}
      </>
    );
  }

  return () => null;
};
